import { useLocale } from "../locale/locale-context.tsx";
import { ErrorShell } from "./not-found.tsx";

export function ServerErrorPage() {
  const { t } = useLocale();
  return (
    <ErrorShell
      watermark="500"
      heading={t("errors.500.title")}
      subtitle={t("errors.500.subtitle")}
      cta={t("errors.500.cta")}
      // Hard reload — the most useful thing after a 500 is to retry the same
      // URL, not navigate away. Leaving as `/` here so users get back to a
      // known-good surface; the watch page surfaces its own retry already.
      ctaHref="/"
    />
  );
}
